import { FC } from 'react';

import { Button, Heading, Paragraph, TextSpacing } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { LeadSuccessProps } from '../../model';
import { LeadTestID } from '../../test-ids';
import { SuccessMessage, SuccessWrapper } from './LeadSuccess.styles';

export const LeadSuccess: FC<LeadSuccessProps> = ({ responseTimeText, successExitLink, successExitLinkText }) => {
    const { t } = useTranslations();

    const handleExitClick = () => {
        if (successExitLink) {
            window.location.assign(successExitLink);
        }
    };

    return (
        <SuccessWrapper data-test={LeadTestID.LEAD_SUCCESS}>
            <TextSpacing>
                <Heading tag="h2" variant="title-400">
                    {t['lead.success.title']}
                </Heading>
                <SuccessMessage>{t['lead.success.message']}</SuccessMessage>
                <Paragraph>{responseTimeText || t['lead.success.response_time']}</Paragraph>
                {!!successExitLink && !!successExitLinkText && (
                    <Button variant="secondary" onClick={handleExitClick}>
                        {successExitLinkText}
                    </Button>
                )}
            </TextSpacing>
        </SuccessWrapper>
    );
};
